import { memo } from 'react';

import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import translation from 'src/components/translation';
import { REGULAR_SPACE } from 'src/utils/constants/symbols';

const TrlKeys = {
    dbAccess: 'employer.price2.basket.access',
    included: 'price.cart.resume-access.publications.included.1',
};

interface TitleProps {
    showPublicationsText: boolean;
}

const Title: TranslatedComponent<TitleProps> = ({ trls, showPublicationsText }) => {
    return (
        <span>
            {trls[TrlKeys.dbAccess]}
            {showPublicationsText && (
                <>
                    {REGULAR_SPACE}
                    {trls[TrlKeys.included]}
                </>
            )}
        </span>
    );
};

export default memo(translation(Title));
